import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Point A Hotel Own System**
 *
 * @exports bs_328
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_328
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        setTimeout(thn.pageCheck, 600);
    };
    /**
       * @memberOf module:bs_328
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const container = document.documentElement;
        if (container) {
            let refreshLang = thn.debounce(thn.languageCheck, 400);
            thn.observeDom(container, refreshLang, {
                attributes: true,
                attributeFilter: ['lang'],
            });
            thn.shutdown(() => {
                thn.stopObserveDom(container, refreshLang);
                refreshLang = null;
            });
        }
    };
    /**
       * @memberOf module:bs_325
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        thn.shutdown(thn.delegate('click', 'button.btn--currency', () => {
            setTimeout(() => thn.widgets.price.refresh(), 500);
        }));
    };
    /**
       * @memberOf module:bs_328
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        // Dates
        const datesElement = document.querySelector('.booking-summary > div:nth-child(3) .item-label-thin');
        const dates = datesElement?.textContent?.split('-').map((rawDate) => translateDate(rawDate?.replace(/\./g, ''), thn.data.language));
        if (!thn.empty(dates)) {
            widgetData.dateBegin = dates[0];
            widgetData.dateEnd = dates[1];
            widgetData.nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        // Rooms and actual room
        const rooms = document.querySelectorAll('.booking-summary .item');
        const numOfRooms = rooms?.length || 1;
        let actualRoom = 1;
        if (numOfRooms !== 1) {
            actualRoom = window.location.hash.slice(-1);
        }
        // Occupancy
        widgetData.adults = thn.parseNumber(rooms[actualRoom - 1]?.querySelector('.item-label-regular')?.textContent) || 2;
        widgetData.children = 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        // Prices
        const prices = [...document.querySelectorAll('.room-item')]
            .map((room) => thn.parseNumber(((room.querySelector('.discounted-price') || {}).textContent || false)))
            .filter(Boolean)
            .sort((a, b) => a - b);
        // Currency
        widgetData.currency = thn.parseCurrency(document.querySelector('.now-price')?.textContent) || document.querySelector('.currency-wrapper label')?.textContent || 'GBP';
        if (!thn.empty(prices)) {
            widgetData.price = prices[0] / widgetData.nights;
            widgetData.set = true;
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_328
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        // We have to inherit dateBegin & dateEnd from a previous visit
        // Because the URL of the BE doesn't refresh correctly when you make a new search
        // and booking summary page doesn't include year information.
        const widgetData = {};
        const dataLayer = window.dataLayer;
        // Booking ID
        widgetData.bookingId = thn.objectGet(dataLayer, 'transactionId', { first: false }) || document.querySelector('.confirmation-number span')?.textContent.split('.')[1]?.trim();
        // Price && Currency
        widgetData.price = thn.objectGet(dataLayer, 'transactionTotal', { first: false });
        widgetData.currency = thn.objectGet(dataLayer, 'currencyCode', { first: false });
        return widgetData;
    };
    return engine;
}

export { factory };
